<template>
    <v-dialog v-model="deleteUserDialog" max-width="540">
        <template v-slot:activator="{ on, attrs }">
            <v-btn :color="dangerColor" icon v-bind="attrs" v-on="on">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                            mdi-delete
                        </v-icon>
                    </template>
                    <span>Remove</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Remove Residence Assistant
            </v-card-title>
            <v-card-text>
                Are you sure you would like to remove <b>{{ item.cn }}</b> as a Residence Assistant? This action can not
                be
                undone! Please click confirm to proceed.
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn ref="confirmBtn" :color="dangerColor" text @click="removeUser()">
                    Confirm
                </v-btn>
                <v-btn :color="warningColor" text @click="closeDialog()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'delete-user',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            currentUser: '',
            deleteUserDialog: false
        }
    },
    methods: {
        closeDialog() {
            this.deleteUserDialog = false;
        },
        removeUser() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?deleteRA`;
            let cn = this.item.cn;

            // Set loader
            that.$refs.confirmBtn.loading = true;

            // Parse array into string
            formData.append('mode', 'deleteRA');
            formData.append('data', JSON.stringify({
                id: this.item.id
            }));

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-account-remove', `${cn} has been successfully removed as a Residence Assistant.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-account-alert', `${cn} could not be removed as a Residence Assistant. ${json.message}.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>